import React, { FC } from 'react';

import { List } from '@lglp/components';
import { FooterLink, FooterLinkTypes } from '@lglp/prismic-client';

import { LinkedComponent } from '../../../LinkedComponent';
import { RGPDButton } from '../../RGPD';
import styles from './FooterLink.module.scss';

export const FooterLinks: FC<FooterLinksProps> = ({ menu, className }) => {
  return (
    <List className={[styles.footerLinks, className]}>
      {menu?.map(({ type, ...menu }, i) => (
        <List.Item key={`link-${type}-${i}`} className={styles.footerLinkItem}>
          {type === FooterLinkTypes.FOOTER_LINK && (
            <LinkedComponent
              className={styles.footerLink}
              link={(menu as FooterLink)?.link}
            >
              {menu?.label}
            </LinkedComponent>
          )}
          {type === FooterLinkTypes.RGPD_LINK && (
            <RGPDButton className={styles.footerLink}>{menu?.label}</RGPDButton>
          )}
        </List.Item>
      ))}
    </List>
  );
};

type FooterLinksProps = {
  menu: FooterLink[];
  className?: string;
};
